import { Type } from '@warp-drive/core-types/symbols';
import type EligibilityFileJobLogModel from './eligibility-file-job-log.ts';
import Model, { attr, belongsTo } from '@ember-data/model';

export default class EligibilityFileJobLogEntryModel extends Model {
  @attr declare eligibilityFileJobLogId: string;
  @attr declare logLevel: string;
  @attr declare key: string;
  @attr declare message: string;
  @attr declare data: Record<string, unknown>;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('eligibility-file-job-log', { async: false, inverse: 'eligibilityFileJobLogEntries' })
  declare eligibilityFileJobLog: EligibilityFileJobLogModel;

  [Type] = 'eligibility-file-job-log-entry' as const;
}
